import { createHttpActions } from '@next/arable-lib/shared';
import { createAction, props } from '@ngrx/store';

import { CropFieldNutrientCalculationsResponse } from '../shared/models/models';

export const [
  loadBFPData,
  loadBFPDataSuccess,
  loadBFPDataFailure,
] = createHttpActions<
  { year: number },
  { data: CropFieldNutrientCalculationsResponse[]; customerId: number | null },
  { error: string }
>('Load BFP Data');

export const loadBFPDataIgnored = createAction('Load BFP Data Ignored');

export const resetBFPData = createAction('Reset BFP Data', props<{ year: number }>());



